<template>
  <header class="headerCom">
    <img class="back" src="/images/public/back.png" @click="goBack" />
    <slot></slot>
  </header>
</template>

<script>
import publicObj from "@/assets/js/public";
import zhugeObj from "@/assets/js/track";
import { Dialog } from "vant";
export default {
  name: "headerCom",
  data() {
    return {};
  },
  props: {
    scheme: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  computed: {},
  created() {},
  computed: {
    routerindex() {
      return this.$store.state.routerIndex;
    }
  },
  mounted() {},
  methods: {
    goBack() {
      const fromMrntion =
        this.$route.query.fromMrntion ||
        publicObj.GetQueryString("fromMrntion") ||
        "203";
      if (this.$route.name == "teamDetail") {
        if (this.$route.query.orderCode) {
          this.$router.push({ name: "orderList", params: { type: 1 } });
          return;
        } else {
          if (this.routerindex > 1) {
            this.$router.push({ name: "orderList", params: { type: 1 } });
            return;
          } else {
            this.$router.push({ name: "homeIndex" });
            return;
          }
        }
      }

      if (this.$route.name == "pay") {
        const isTeam = this.$route.query.isTeam || publicObj.GetQueryString("isTeam")
        let type = 1;
        this.scheme ? (type = 2) : (type = 1);
        if(isTeam){
          zhugeObj.track({
            title: "支付页-拼团挽留弹窗-曝光"
          });
          Dialog.confirm({
            title: "",
            confirmButtonText: "让我想想",
            cancelButtonText: "不要了",
            message: "你要放弃399的礼品吗？"
          }).then(() => {
              zhugeObj.track({
                title: "支付页-拼团挽留弹窗再想想-点击"
              });
            })
            .catch(() => {
              this.$router.push({ name: "orderList", params: { type } });
            });
        }else{
          zhugeObj.track({
            title: "支付页-挽留弹窗再想想-曝光"
          });
          Dialog.confirm({
            title: "",
            message: "您是否确定取消支付?",
            confirmButtonText: "确定",
            cancelButtonText: "再想想",
          }).then(() => {
              this.$router.push({ name: "orderList", params: { type } });
            })
            .catch(() => {
              // on cancel
            });
        }
        
      } else if (this.$route.name == "couponList" && !fromMrntion) {
        this.$router.push({ name: "myIndex" });
      } else {
        this.routerindex > 1
          ? this.$router.back()
          : this.$router.push({ name: "homeIndex" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.headerCom {
  background: transparent;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 60px;
  -webkit-transform: translateZ(0);
  padding: 20px;
  .back {
    width: 60px;
    position: absolute;
    left: 30px;
    top: 20px;
  }
}
</style>
